// extracted by mini-css-extract-plugin
export default {"counter":"styles_counter__I5Fot","hover":"styles_hover__BZvzJ","fancy":"styles_fancy__TIeOG"};